// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tooltip-module__font-s-10___bTKjQ {
  font-size: 10px !important;
}

.Tooltip-module__font-s-12___LNET5 {
  font-size: 12px !important;
}

.Tooltip-module__font-s-13___ZPBj7 {
  font-size: 13px !important;
}

.Tooltip-module__font-s-14___jpHl1 {
  font-size: 14px !important;
}

.Tooltip-module__font-s-15___TweCr {
  font-size: 15px !important;
}

.Tooltip-module__font-s-16___j6EqD {
  font-size: 16px !important;
}

.Tooltip-module__font-s-18___o_w8Q {
  font-size: 18px !important;
}

.Tooltip-module__font-s-20___zGNs1 {
  font-size: 20px !important;
}

.Tooltip-module__font-s-22___m2XS1 {
  font-size: 22px !important;
}

.Tooltip-module__font-s-28___rhiCw {
  font-size: 28px !important;
}

.Tooltip-module__font-w-400___jFsEH {
  font-weight: 400 !important;
}

.Tooltip-module__font-w-500___xIkja {
  font-weight: 500 !important;
}

.Tooltip-module__font-w-600___wgqIu {
  font-weight: 600 !important;
}

.Tooltip-module__font-w-700___Waz5j {
  font-weight: 700 !important;
}

.Tooltip-module__p-5___tsku1 {
  padding: 5px !important;
}

.Tooltip-module__p-12___TPoEE {
  padding: 12px !important;
}

.Tooltip-module__p-16___FzZ41 {
  padding: 16px !important;
}

.Tooltip-module__p-30___zKLwN {
  padding: 30px !important;
}

.Tooltip-module__p-b-0___wv_Kq {
  padding-bottom: 0 !important;
}

.Tooltip-module__p-b-5___T35lg {
  padding-bottom: 5px !important;
}

.Tooltip-module__p-b-10___jbvrP {
  padding-bottom: 10px !important;
}

.Tooltip-module__p-b-12___p3l7w {
  padding-bottom: 12px !important;
}

.Tooltip-module__p-b-16___t405K {
  padding-bottom: 16px !important;
}

.Tooltip-module__p-b-18___qc7SF {
  padding-bottom: 18px !important;
}

.Tooltip-module__p-b-20___xqGMI {
  padding-bottom: 20px !important;
}

.Tooltip-module__p-b-25___CvjeG {
  padding-bottom: 25px !important;
}

.Tooltip-module__p-b-30___IoLP1 {
  padding-bottom: 30px !important;
}

.Tooltip-module__p-b-50___DJD8s {
  padding-bottom: 50px !important;
}

.Tooltip-module__p-t-0___yPj7G {
  padding-top: 0 !important;
}

.Tooltip-module__p-t-12___qjViv {
  padding-top: 12px !important;
}

.Tooltip-module__p-t-16___llCZS {
  padding-top: 16px !important;
}

.Tooltip-module__p-t-18___d1ncJ {
  padding-top: 18px !important;
}

.Tooltip-module__p-t-20___SDiWT {
  padding-top: 20px !important;
}

.Tooltip-module__p-t-30___zzJRA {
  padding-top: 30px !important;
}

.Tooltip-module__p-t-40___xs69L {
  padding-top: 40px !important;
}

.Tooltip-module__p-t-50___A_7JT {
  padding-top: 50px !important;
}

.Tooltip-module__p-l-20___rjM8h {
  padding-left: 20px !important;
}

.Tooltip-module__p-l-30___inq1o {
  padding-left: 30px !important;
}

.Tooltip-module__p-l-40___Fsi5b {
  padding-left: 40px !important;
}

.Tooltip-module__p-r-16___jH7tn {
  padding-right: 16px !important;
}

.Tooltip-module__p-r-20___No3SS {
  padding-right: 20px !important;
}

.Tooltip-module__p-r-30___HSr7B {
  padding-right: 30px !important;
}

.Tooltip-module__p-r-50___iugWn {
  padding-right: 50px !important;
}

.Tooltip-module__p-r-60___kzT3i {
  padding-right: 60px !important;
}

.Tooltip-module__m-b-1___QJVx_ {
  margin-bottom: 1px !important;
}

.Tooltip-module__m-b-2___jO_9G {
  margin-bottom: 2px !important;
}

.Tooltip-module__m-b-6___bCbMF {
  margin-bottom: 6px !important;
}

.Tooltip-module__m-b-8___WcStM {
  margin-bottom: 8px !important;
}

.Tooltip-module__m-b-10___UDw4j {
  margin-bottom: 10px !important;
}

.Tooltip-module__m-b-14___RzibS {
  margin-bottom: 14px !important;
}

.Tooltip-module__m-b-16___fXGGM {
  margin-bottom: 16px !important;
}

.Tooltip-module__m-b-20___xL2wg {
  margin-bottom: 20px !important;
}

.Tooltip-module__m-b-22___ogbRz {
  margin-bottom: 22px !important;
}

.Tooltip-module__m-b-24___yadK_ {
  margin-bottom: 24px !important;
}

.Tooltip-module__m-b-30___jFcxF {
  margin-bottom: 30px !important;
}

.Tooltip-module__m-b-32___H73WD {
  margin-bottom: 32px !important;
}

.Tooltip-module__m-b-40___L_0rz {
  margin-bottom: 40px !important;
}

.Tooltip-module__m-t-2___t5KhG {
  margin-top: 2px !important;
}

.Tooltip-module__m-t-3___GVmIq {
  margin-top: 3px !important;
}

.Tooltip-module__m-t-4___CbIWm {
  margin-top: 4px !important;
}

.Tooltip-module__m-t-5___HwXNH {
  margin-top: 5px !important;
}

.Tooltip-module__m-t-8___fI2Kr {
  margin-top: 8px !important;
}

.Tooltip-module__m-t-10___CI4WQ {
  margin-top: 10px !important;
}

.Tooltip-module__m-t-15___DdV8d {
  margin-top: 15px !important;
}

.Tooltip-module__m-t-16___W1i9_ {
  margin-top: 16px !important;
}

.Tooltip-module__m-t-20___pb7Wy {
  margin-top: 20px !important;
}

.Tooltip-module__m-t-22___TEv74 {
  margin-top: 22px !important;
}

.Tooltip-module__m-t-30___XDmp3 {
  margin-top: 30px !important;
}

.Tooltip-module__m-t-32___lIk_9 {
  margin-top: 32px !important;
}

.Tooltip-module__m-l-auto___YuCwA {
  margin-left: auto !important;
}

.Tooltip-module__m-l-4___srzyg {
  margin-left: 4px !important;
}

.Tooltip-module__m-l-5___wKUX6 {
  margin-left: 5px !important;
}

.Tooltip-module__m-l-6___mpZjx {
  margin-left: 6px !important;
}

.Tooltip-module__m-l-8___PaBOF {
  margin-left: 8px !important;
}

.Tooltip-module__m-l-10___VIzqU {
  margin-left: 10px !important;
}

.Tooltip-module__m-l-16___w_VWv {
  margin-left: 16px !important;
}

.Tooltip-module__m-l-20___jp_s7 {
  margin-left: 20px !important;
}

.Tooltip-module__m-l-24___JNJqZ {
  margin-left: 24px !important;
}

.Tooltip-module__m-l-30___nMyHK {
  margin-left: 30px !important;
}

.Tooltip-module__m-l-35___HH5Rb {
  margin-left: 35px !important;
}

.Tooltip-module__m-l-40___A2u8_ {
  margin-left: 40px !important;
}

.Tooltip-module__m-r-8___zpsLy {
  margin-right: 8px !important;
}

.Tooltip-module__m-r-10___eBCQr {
  margin-right: 10px !important;
}

.Tooltip-module__m-r-16___ux7AN {
  margin-right: 16px !important;
}

.Tooltip-module__m-r-20___GpbsV {
  margin-right: 20px !important;
}

.Tooltip-module__m-r-24___TROJu {
  margin-right: 24px !important;
}

.Tooltip-module__m-r-30___u8suv {
  margin-right: 30px !important;
}

.Tooltip-module__m-r-40___w3_0I {
  margin-right: 40px !important;
}

.Tooltip-module__border-r-3___mvtDb {
  border-radius: 3px !important;
}

.Tooltip-module__border-r-4___a8tah {
  border-radius: 4px !important;
}

.Tooltip-module__border-r-6___IoTsv {
  border-radius: 6px !important;
}

.Tooltip-module__border-r-10___i7Ypl {
  border-radius: 10px !important;
}

.Tooltip-module__border-r-12___EH4kp {
  border-radius: 12px !important;
}

.Tooltip-module__border-r-16___R6tqB {
  border-radius: 16px !important;
}

.Tooltip-module__border-r-50___XBB4y {
  border-radius: 50% !important;
}

.Tooltip-module__primary-border___rrv_3 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Tooltip-module__primary-border-b___NnrNc {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Tooltip-module__primary-border-t___vTRSm {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Tooltip-module__primary-border-l___FkJW3 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Tooltip-module__primary-border-r___KmehJ {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Tooltip-module__secondary-border___aK3X2 {
  border: 1px solid #637768;
}

.Tooltip-module__secondary-border-b___NnNqx {
  border-bottom: 1px solid #637768;
}

.Tooltip-module__secondary-border-t___zMUhG {
  border-top: 1px solid #637768;
}

.Tooltip-module__secondary-border-l___nxqLO {
  border-left: 1px solid #637768;
}

.Tooltip-module__secondary-border-r___zipne {
  border-right: 1px solid #637768;
}

.Tooltip-module__gap-0___ZeojI {
  gap: 0 !important;
}

.Tooltip-module__gap-2___fsqiB {
  gap: 2px !important;
}

.Tooltip-module__gap-4___UCi7L {
  gap: 4px !important;
}

.Tooltip-module__gap-5___fxO3z {
  gap: 5px !important;
}

.Tooltip-module__gap-6___Hx9qA {
  gap: 6px !important;
}

.Tooltip-module__gap-8___RdUB1 {
  gap: 8px !important;
}

.Tooltip-module__gap-10___qoFHk {
  gap: 10px !important;
}

.Tooltip-module__gap-12___Kkkem {
  gap: 12px !important;
}

.Tooltip-module__gap-14___ggANp {
  gap: 14px !important;
}

.Tooltip-module__gap-16___Q4_Pg {
  gap: 16px !important;
}

.Tooltip-module__gap-18___ldjkB {
  gap: 18px !important;
}

.Tooltip-module__gap-20___aSkrS {
  gap: 20px !important;
}

.Tooltip-module__gap-24___Cp76d {
  gap: 24px !important;
}

.Tooltip-module__gap-26____jcme {
  gap: 26px !important;
}

.Tooltip-module__gap-30___R6lIp {
  gap: 30px !important;
}

.Tooltip-module__gap-32___Lj7LA {
  gap: 32px !important;
}

.Tooltip-module__gap-40___AvNsR {
  gap: 40px !important;
}

.Tooltip-module__gap-50___wiwsI {
  gap: 50px !important;
}

.Tooltip-module__flex-1___kmMW2 {
  flex: 1;
}

.Tooltip-module__flex-none___HHE0B {
  flex: none !important;
}

.Tooltip-module__flex-column___tI2NF {
  display: flex;
  flex-direction: column !important;
}

.Tooltip-module__flex-row___kTF74 {
  display: flex;
  flex-direction: row !important;
}

.Tooltip-module__vertically-centered___DTvEB {
  display: flex;
  align-items: center !important;
}

.Tooltip-module__horizontally-centered___SejMY {
  display: flex;
  justify-content: center !important;
}

.Tooltip-module__horizontally-end___cqFVe {
  display: flex;
  justify-content: end !important;
}

.Tooltip-module__vertically-start___D8c9U {
  display: flex;
  align-items: start !important;
}

.Tooltip-module__space-between___axrg5 {
  display: flex;
  justify-content: space-between !important;
}

.Tooltip-module__flex-wrap___F0Jzm {
  flex-wrap: wrap !important;
}

.Tooltip-module__height-100___P4nfq {
  height: 100%;
}

.Tooltip-module__width-50___znbuA {
  width: 50% !important;
}

.Tooltip-module__width-100___ngqk6 {
  width: 100%;
}

.Tooltip-module__cursor-pointer___UwyKE {
  cursor: pointer;
}

.Tooltip-module__cursor-not-allowed___hIbFF {
  cursor: not-allowed !important;
}

.Tooltip-module__absolute-centered___lBpoI {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Tooltip-module__absolute___bl53o {
  position: absolute;
}

.Tooltip-module__relative___BlkoF {
  position: relative;
}

.Tooltip-module__fixed___R_e8o {
  position: fixed;
}

.Tooltip-module__visible___EuoFR {
  opacity: 1;
}

.Tooltip-module__invisible___xcFh0 {
  opacity: 0;
}

.Tooltip-module__col-90___vEVc4 {
  width: 90% !important;
}

.Tooltip-module__col-auto___yaxUb {
  width: auto !important;
}

.Tooltip-module__medical-tabs___RfOTo {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Tooltip-module__medical-table-new___vtu9X {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Tooltip-module__medical-table-new___vtu9X:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Tooltip-module__medical-table-new___vtu9X::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Tooltip-module__medical-table-new___vtu9X::-webkit-scrollbar-track {
  display: none;
}
.Tooltip-module__medical-table-new___vtu9X.Tooltip-module__no-pagination___WZ8Lq {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Tooltip-module__medical-table-new___vtu9X.Tooltip-module__no-pagination___WZ8Lq:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Tooltip-module__medical-table-new___vtu9X.Tooltip-module__no-pagination___WZ8Lq::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Tooltip-module__medical-table-new___vtu9X.Tooltip-module__no-pagination___WZ8Lq::-webkit-scrollbar-track {
  display: none;
}

.Tooltip-module__medical-table-empty___lC2nL {
  padding: 14px 40px !important;
}

.Tooltip-module__icon-btn___usXCW {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Tooltip-module__search-icon___udSBu {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Tooltip-module__disable-select___gtB3K {
  user-select: none;
}

.Tooltip-module__break-word___s5wc7 {
  word-break: break-word;
}

.Tooltip-module__popup-clear-btn___MDsTa {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Tooltip-module__scroll-m-b-20___mgdnS {
  scroll-margin-bottom: 20px;
}

.Tooltip-module__wrapper___eivoQ {
  width: 100%;
}
.Tooltip-module__wrapper___eivoQ .Tooltip-module__title___KZ9kf {
  color: white;
  background-color: rgb(91, 91, 91);
  width: max-content;
  line-height: 16px;
  padding: 5px 8px;
  max-width: 300px;
  opacity: 0.9;
  z-index: 10;
  word-wrap: break-word;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/Tooltip/Tooltip.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,WAAA;AA8pBF;AA5pBE;EACE,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.wrapper {\n  width: 100%;\n\n  .title {\n    color: get-color(white);\n    background-color: rgb(91, 91, 91);\n    width: max-content;\n    line-height: 16px;\n    padding: 5px 8px;\n    max-width: 300px;\n    opacity: 0.9;\n    z-index: 10;\n    word-wrap: break-word;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Tooltip-module__font-s-10___bTKjQ`,
	"fontS12": `Tooltip-module__font-s-12___LNET5`,
	"fontS13": `Tooltip-module__font-s-13___ZPBj7`,
	"fontS14": `Tooltip-module__font-s-14___jpHl1`,
	"fontS15": `Tooltip-module__font-s-15___TweCr`,
	"fontS16": `Tooltip-module__font-s-16___j6EqD`,
	"fontS18": `Tooltip-module__font-s-18___o_w8Q`,
	"fontS20": `Tooltip-module__font-s-20___zGNs1`,
	"fontS22": `Tooltip-module__font-s-22___m2XS1`,
	"fontS28": `Tooltip-module__font-s-28___rhiCw`,
	"fontW400": `Tooltip-module__font-w-400___jFsEH`,
	"fontW500": `Tooltip-module__font-w-500___xIkja`,
	"fontW600": `Tooltip-module__font-w-600___wgqIu`,
	"fontW700": `Tooltip-module__font-w-700___Waz5j`,
	"p5": `Tooltip-module__p-5___tsku1`,
	"p12": `Tooltip-module__p-12___TPoEE`,
	"p16": `Tooltip-module__p-16___FzZ41`,
	"p30": `Tooltip-module__p-30___zKLwN`,
	"pB0": `Tooltip-module__p-b-0___wv_Kq`,
	"pB5": `Tooltip-module__p-b-5___T35lg`,
	"pB10": `Tooltip-module__p-b-10___jbvrP`,
	"pB12": `Tooltip-module__p-b-12___p3l7w`,
	"pB16": `Tooltip-module__p-b-16___t405K`,
	"pB18": `Tooltip-module__p-b-18___qc7SF`,
	"pB20": `Tooltip-module__p-b-20___xqGMI`,
	"pB25": `Tooltip-module__p-b-25___CvjeG`,
	"pB30": `Tooltip-module__p-b-30___IoLP1`,
	"pB50": `Tooltip-module__p-b-50___DJD8s`,
	"pT0": `Tooltip-module__p-t-0___yPj7G`,
	"pT12": `Tooltip-module__p-t-12___qjViv`,
	"pT16": `Tooltip-module__p-t-16___llCZS`,
	"pT18": `Tooltip-module__p-t-18___d1ncJ`,
	"pT20": `Tooltip-module__p-t-20___SDiWT`,
	"pT30": `Tooltip-module__p-t-30___zzJRA`,
	"pT40": `Tooltip-module__p-t-40___xs69L`,
	"pT50": `Tooltip-module__p-t-50___A_7JT`,
	"pL20": `Tooltip-module__p-l-20___rjM8h`,
	"pL30": `Tooltip-module__p-l-30___inq1o`,
	"pL40": `Tooltip-module__p-l-40___Fsi5b`,
	"pR16": `Tooltip-module__p-r-16___jH7tn`,
	"pR20": `Tooltip-module__p-r-20___No3SS`,
	"pR30": `Tooltip-module__p-r-30___HSr7B`,
	"pR50": `Tooltip-module__p-r-50___iugWn`,
	"pR60": `Tooltip-module__p-r-60___kzT3i`,
	"mB1": `Tooltip-module__m-b-1___QJVx_`,
	"mB2": `Tooltip-module__m-b-2___jO_9G`,
	"mB6": `Tooltip-module__m-b-6___bCbMF`,
	"mB8": `Tooltip-module__m-b-8___WcStM`,
	"mB10": `Tooltip-module__m-b-10___UDw4j`,
	"mB14": `Tooltip-module__m-b-14___RzibS`,
	"mB16": `Tooltip-module__m-b-16___fXGGM`,
	"mB20": `Tooltip-module__m-b-20___xL2wg`,
	"mB22": `Tooltip-module__m-b-22___ogbRz`,
	"mB24": `Tooltip-module__m-b-24___yadK_`,
	"mB30": `Tooltip-module__m-b-30___jFcxF`,
	"mB32": `Tooltip-module__m-b-32___H73WD`,
	"mB40": `Tooltip-module__m-b-40___L_0rz`,
	"mT2": `Tooltip-module__m-t-2___t5KhG`,
	"mT3": `Tooltip-module__m-t-3___GVmIq`,
	"mT4": `Tooltip-module__m-t-4___CbIWm`,
	"mT5": `Tooltip-module__m-t-5___HwXNH`,
	"mT8": `Tooltip-module__m-t-8___fI2Kr`,
	"mT10": `Tooltip-module__m-t-10___CI4WQ`,
	"mT15": `Tooltip-module__m-t-15___DdV8d`,
	"mT16": `Tooltip-module__m-t-16___W1i9_`,
	"mT20": `Tooltip-module__m-t-20___pb7Wy`,
	"mT22": `Tooltip-module__m-t-22___TEv74`,
	"mT30": `Tooltip-module__m-t-30___XDmp3`,
	"mT32": `Tooltip-module__m-t-32___lIk_9`,
	"mLAuto": `Tooltip-module__m-l-auto___YuCwA`,
	"mL4": `Tooltip-module__m-l-4___srzyg`,
	"mL5": `Tooltip-module__m-l-5___wKUX6`,
	"mL6": `Tooltip-module__m-l-6___mpZjx`,
	"mL8": `Tooltip-module__m-l-8___PaBOF`,
	"mL10": `Tooltip-module__m-l-10___VIzqU`,
	"mL16": `Tooltip-module__m-l-16___w_VWv`,
	"mL20": `Tooltip-module__m-l-20___jp_s7`,
	"mL24": `Tooltip-module__m-l-24___JNJqZ`,
	"mL30": `Tooltip-module__m-l-30___nMyHK`,
	"mL35": `Tooltip-module__m-l-35___HH5Rb`,
	"mL40": `Tooltip-module__m-l-40___A2u8_`,
	"mR8": `Tooltip-module__m-r-8___zpsLy`,
	"mR10": `Tooltip-module__m-r-10___eBCQr`,
	"mR16": `Tooltip-module__m-r-16___ux7AN`,
	"mR20": `Tooltip-module__m-r-20___GpbsV`,
	"mR24": `Tooltip-module__m-r-24___TROJu`,
	"mR30": `Tooltip-module__m-r-30___u8suv`,
	"mR40": `Tooltip-module__m-r-40___w3_0I`,
	"borderR3": `Tooltip-module__border-r-3___mvtDb`,
	"borderR4": `Tooltip-module__border-r-4___a8tah`,
	"borderR6": `Tooltip-module__border-r-6___IoTsv`,
	"borderR10": `Tooltip-module__border-r-10___i7Ypl`,
	"borderR12": `Tooltip-module__border-r-12___EH4kp`,
	"borderR16": `Tooltip-module__border-r-16___R6tqB`,
	"borderR50": `Tooltip-module__border-r-50___XBB4y`,
	"primaryBorder": `Tooltip-module__primary-border___rrv_3`,
	"primaryBorderB": `Tooltip-module__primary-border-b___NnrNc`,
	"primaryBorderT": `Tooltip-module__primary-border-t___vTRSm`,
	"primaryBorderL": `Tooltip-module__primary-border-l___FkJW3`,
	"primaryBorderR": `Tooltip-module__primary-border-r___KmehJ`,
	"secondaryBorder": `Tooltip-module__secondary-border___aK3X2`,
	"secondaryBorderB": `Tooltip-module__secondary-border-b___NnNqx`,
	"secondaryBorderT": `Tooltip-module__secondary-border-t___zMUhG`,
	"secondaryBorderL": `Tooltip-module__secondary-border-l___nxqLO`,
	"secondaryBorderR": `Tooltip-module__secondary-border-r___zipne`,
	"gap0": `Tooltip-module__gap-0___ZeojI`,
	"gap2": `Tooltip-module__gap-2___fsqiB`,
	"gap4": `Tooltip-module__gap-4___UCi7L`,
	"gap5": `Tooltip-module__gap-5___fxO3z`,
	"gap6": `Tooltip-module__gap-6___Hx9qA`,
	"gap8": `Tooltip-module__gap-8___RdUB1`,
	"gap10": `Tooltip-module__gap-10___qoFHk`,
	"gap12": `Tooltip-module__gap-12___Kkkem`,
	"gap14": `Tooltip-module__gap-14___ggANp`,
	"gap16": `Tooltip-module__gap-16___Q4_Pg`,
	"gap18": `Tooltip-module__gap-18___ldjkB`,
	"gap20": `Tooltip-module__gap-20___aSkrS`,
	"gap24": `Tooltip-module__gap-24___Cp76d`,
	"gap26": `Tooltip-module__gap-26____jcme`,
	"gap30": `Tooltip-module__gap-30___R6lIp`,
	"gap32": `Tooltip-module__gap-32___Lj7LA`,
	"gap40": `Tooltip-module__gap-40___AvNsR`,
	"gap50": `Tooltip-module__gap-50___wiwsI`,
	"flex1": `Tooltip-module__flex-1___kmMW2`,
	"flexNone": `Tooltip-module__flex-none___HHE0B`,
	"flexColumn": `Tooltip-module__flex-column___tI2NF`,
	"flexRow": `Tooltip-module__flex-row___kTF74`,
	"verticallyCentered": `Tooltip-module__vertically-centered___DTvEB`,
	"horizontallyCentered": `Tooltip-module__horizontally-centered___SejMY`,
	"horizontallyEnd": `Tooltip-module__horizontally-end___cqFVe`,
	"verticallyStart": `Tooltip-module__vertically-start___D8c9U`,
	"spaceBetween": `Tooltip-module__space-between___axrg5`,
	"flexWrap": `Tooltip-module__flex-wrap___F0Jzm`,
	"height100": `Tooltip-module__height-100___P4nfq`,
	"width50": `Tooltip-module__width-50___znbuA`,
	"width100": `Tooltip-module__width-100___ngqk6`,
	"cursorPointer": `Tooltip-module__cursor-pointer___UwyKE`,
	"cursorNotAllowed": `Tooltip-module__cursor-not-allowed___hIbFF`,
	"absoluteCentered": `Tooltip-module__absolute-centered___lBpoI`,
	"absolute": `Tooltip-module__absolute___bl53o`,
	"relative": `Tooltip-module__relative___BlkoF`,
	"fixed": `Tooltip-module__fixed___R_e8o`,
	"visible": `Tooltip-module__visible___EuoFR`,
	"invisible": `Tooltip-module__invisible___xcFh0`,
	"col90": `Tooltip-module__col-90___vEVc4`,
	"colAuto": `Tooltip-module__col-auto___yaxUb`,
	"medicalTabs": `Tooltip-module__medical-tabs___RfOTo`,
	"medicalTableNew": `Tooltip-module__medical-table-new___vtu9X`,
	"noPagination": `Tooltip-module__no-pagination___WZ8Lq`,
	"medicalTableEmpty": `Tooltip-module__medical-table-empty___lC2nL`,
	"iconBtn": `Tooltip-module__icon-btn___usXCW`,
	"searchIcon": `Tooltip-module__search-icon___udSBu`,
	"disableSelect": `Tooltip-module__disable-select___gtB3K`,
	"breakWord": `Tooltip-module__break-word___s5wc7`,
	"popupClearBtn": `Tooltip-module__popup-clear-btn___MDsTa`,
	"scrollMB20": `Tooltip-module__scroll-m-b-20___mgdnS`,
	"wrapper": `Tooltip-module__wrapper___eivoQ`,
	"title": `Tooltip-module__title___KZ9kf`
};
module.exports = ___CSS_LOADER_EXPORT___;
